import StocksGestionRapportActiviteSyntheseController from './stocks.gestion.rapport.activite.synthese.controller';
import Template from './stocks.gestion.rapport.activite.synthese.html';

export default {
	controller: StocksGestionRapportActiviteSyntheseController,
	template: Template
};
